import axios from 'axios';
import { BASE_URL } from '../Utlils';

// create new supplier :
export const createNewSupplier = async (data) => {
  try {
    const { data: responseData } = await axios.post(
      `${BASE_URL}/suppliers/create-new-supplier`,
      data,
    );
    return responseData?.data;
  } catch (error) {
    console.log('error occurred', error);
    return { error: error || 'An Unknown error occured' };
  }
};

export const fetchSupplierCount = async (orgId) => {
  try {
    const request = await axios.post(
      `${BASE_URL}/suppliers/all-suppliers-count`,
      { orgId },
    );
    const json = request.data;

    return {
      success: true,
      data: json,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};
// get all suppliers count :
export const getAllSupplierCount = async ({ orgId } = {}) => {
  const result = await fetchSupplierCount(orgId);
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

const fetchAllSuppliers = async (data, signal) => {
  try {
    const tab = data?.tab || '1';
    const request = await axios.post(
      `${BASE_URL}/suppliers/${tab}/all-suppliers`,
      {
        ...data,
        signal,
      },
    );
    const json = request.data;
    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }
    return {
      success: true,
      data: json,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};

// get all suppliers (swr call):
export const getAllSuppliers = async (data, { signal } = {}) => {
  const result = await fetchAllSuppliers(data, signal);
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

// get single supplier details :
export const fetchSingleSupplierDetails = async (data, signal) => {
  try {
    const request = await axios.get(
      `${BASE_URL}/suppliers/${data.supplierID}/single-supplier-details`,
    );

    const json = request.data;
    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }
    return {
      success: true,
      data: json?.data ?? {},
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};

export const getSingleSupplierDetails = async ({ supplierID }) => {
  const result = await fetchSingleSupplierDetails({ supplierID: supplierID });
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

// get all suppliers list :
export const fetchAllSuppliersList = async (data) => {
  try {
    const { orgId } = data;
    if (!orgId) throw new Error('orgId is required');
    const request = await axios.post(
      `${BASE_URL}/suppliers/all-suppliers-list`,
      { orgId },
    );
    const json = request.data;
    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }
    return {
      success: true,
      data: json?.data ?? [],
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};

export const getAllSuppliersList = async (data) => {
  const result = await fetchAllSuppliersList(data);
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

export const fetchActiveSuppliersList = async (signal) => {
  try {
    const request = await axios.get(
      `${BASE_URL}/suppliers/active-suppliers-list`,
      {
        signal,
      },
    );
    const json = request.data;
    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }
    return {
      success: true,
      data: json?.data ?? [],
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};

export const getActiveSuppliersList = async ({ signal } = {}) => {
  const result = await fetchActiveSuppliersList(signal);
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

export const submitUpdateSupplierStatus = async ({
  supplierID,
  supplierStatus,
}) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/suppliers/${supplierID}/update-supplier-status`,
      {
        status: supplierStatus,
      },
    );
    const json = response.data;
    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }
    return {
      success: true,
      data: json ?? {},
      error: null,
    };
  } catch (error) {
    console.log('error occurred', error);
    return { error: error || 'An Unknown error occured' };
  }
};

export const fetchSupplierPostbackDetails = async (data) => {
  try {
    const request = await axios.get(
      `${BASE_URL}/suppliers/${data.supplierID}/postback-details`,
    );

    const json = request.data;
    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }
    return {
      success: true,
      data: json?.data ?? {},
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};

export const getSupplierPostbackDetails = async ({ supplierID }) => {
  const result = await fetchSupplierPostbackDetails({ supplierID: supplierID });
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

// update supplier postbacks :
export const updateSupplierPostbacks = async (data) => {
  'use server';
  try {
    const response = await axios.patch(
      `${BASE_URL}/suppliers/${data?._id}/update-postback-details`,
      data,
    );
    const json = response.data;
    if (json?.success) {
      return json?.data ?? {};
    } else {
      const error = json;
      throw new Error(error?.message || 'An error occurred');
    }
  } catch (error) {
    console.log('error occurred', error);
    return {
      success: false,
      data: null,
      error: error || 'Network error. Please check your connection.',
    };
  }
};
